export const RATING_SLIDER_THEME_DEFAULT = 'DEFAULT';
export const RATING_SLIDER_THEME_BLUE = 'BLUE';
export const RATING_SLIDER_THEME_GREEN = 'GREEN';
export const RATING_SLIDER_THEME_ORANGE = 'ORANGE';
export const RATING_SLIDER_THEME_RED = 'RED';

export const RANDOMIZE_POLL_GROUPS = 'groups';
export const RANDOMIZE_POLL_SETS = 'sets';
export const RANDOMIZE_POLL_ALL = 'all';

export const OTHERS_ANSWER = 'others';
export const NOT_APPLICABLE_ANSWER = 'not_applicable';

export const AWARD_POINTS = 'AWARD_POINTS';
export const AWARD_SCORES = 'AWARD_SCORES';

export const EMAIL_VALIDATE_REG = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const PHONE_VALIDATE_REG = /^(\+7) \([0-9]{3}\) ([0-9]{3})-([0-9]{2})-([0-9]{2})$/;
export const DATE_VALIDATE_REG = /^([0-9]{2})\.([0-9]{2})\.([0-9]{4})$/;
export const URL_VALIDATE_REG = /^(http|https):\/\/[^ "]+$/;

export const DEFAULT_TEXT_LIMIT = 1500;
